import apiClient from './apiClient';

export const getAllTermine = async () => {
  const response = await apiClient.get('/termine');
  return response.data;
};

export const getTerminById = async (id) => {
  const response = await apiClient.get(`/termine/${id}`);
  return response.data;
};

export const createTermin = async (terminData) => {
  const response = await apiClient.post('/termine', terminData);
  return response.data;
};

export const updateTermin = async (id, terminData) => {
  const response = await apiClient.put(`/termine/${id}`, terminData);
  return response.data;
};

export const deleteTermin = async (id) => {
  const response = await apiClient.delete(`/termine/${id}`);
  return response.data;
};
